<div class="loader-wrapper">
  <div class="loader-26"></div>
  <span class="loading-text" *ngIf="loadingText">{{ loadingText }}</span>
</div>
